import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import './utils/axios'
// 全局设置 axios 发送请求带上cookie
// axios.defaults.withCredentials = true
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'

import './btnPermission.js'

import { HttpServicePlugin } from './utils/request';
import '@/icons' // icon
import '@/permission' // permission control
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc";
dayjs.extend(utc)
Vue.prototype.$day = dayjs;
//引入Dialog组件
import Dialog from './components/Dialog'

// import '@/styles/element-variables.scss'

//将Dialog组件挂载到vue原型上
Vue.prototype.$dialog = Dialog

// 全局日期过滤器
import * as filters from './utils/date'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

//引入全局方法
import global from "./utils/global"
Vue.prototype.global = global;
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

// set ElementUI lang to EN
Vue.use(ElementUI, { locale, size: 'small', zIndex: 3000 })
Vue.use(HttpServicePlugin);
Vue.use(VueAxios, axios)

// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js